const CheckNotNull = Symbol('CheckNotNull');

class AuditAction {
    public autoID: string = '';
    public actionID: string = '';
    public action_type: string = '';
    public action_label: string = '';
    public tables_affected: string[] = [];

    constructor(
        autoID: string,
        actionID: string,
        action_type: string,
        action_label: string,
        tables_affected: string
    ) {
        this.autoID = this[CheckNotNull](autoID) ? autoID : '';
        this.actionID = this[CheckNotNull](actionID) ? actionID : '';
        this.action_type = this[CheckNotNull](action_type) ? action_type : '';
        this.action_label = this[CheckNotNull](action_label) ? action_label : '';
        this.tables_affected = this[CheckNotNull](tables_affected) ? tables_affected.split(',') : [];
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default AuditAction;